import { priorityLabels } from "@p0security/shared/assessment/constants";
import { MonitorBase } from "@p0security/shared/types/assessment/monitor";
import { priorityColor } from "components/Assessment/utils/monitor";
import { StyledTag } from "styles/StyledTags";
import { colors } from "styles/variables";

export const MonitorPriority: React.FC<{
  monitor: Pick<MonitorBase, "priority">;
}> = ({ monitor }) => (
  <StyledTag
    color={priorityColor[monitor?.priority].tagColor ?? colors.tagColors.grey}
    style={{
      width: "5em",
      textAlign: "center",
      marginRight: "0",
    }}
  >
    {priorityLabels[monitor.priority]}
  </StyledTag>
);
